var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    typography = _ref.typography,
    colors = _ref.colors;
  return {
    stemWrapperMarginBottom: spacing.xxSmall,
    stemWrapperMarginLeft: spacing.xSmall,
    stemItemMargin: spacing.xxSmall,
    stemItemFontSize: typography.fontSizeMedium,
    textFontSize: typography.fontSizeMedium,
    textMargin: spacing.xSmall,
    selectPlacholderColor: colors.ash
  };
};
export default generateComponentTheme;